import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { momentDate, timeTableDayFromNumber } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import { Tabs, Tag } from "antd-mobile";

const CircularList = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [dataList, setDataList] = useState([]);
  const [selectedType, setSelectedType] = useState("all");
  const [loader, setLoader] = useState(false);
  const [activeTab, setActiveTab] = useState("all");

  const linkClick = (toUrl) => {
    navigate(toUrl);
  };

  useEffect(() => {
    context.loadSettings();
  }, []);

  useEffect(() => {
    loadData();
  }, [selectedType]);

  const loadData = () => {
    setLoader(true);
    setDataList([]);
    const form = new FormData();
    form.append("type", "circular");
    form.append("selectedType", selectedType);
    form.append("course", context.user.course);
    form.append("uuid", context.user.uuid);
    form.append("from", "student");
    axios.post(ServiceUrl.STUDENTS.MY_NOTIFICATION, form).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
      } else {
      }
      setLoader(false);
    });
  };

  return (
    <>
      <div class="chat-list mt-2">
        {dataList &&
          dataList.length > 0 &&
          dataList.map((item) => {
            return (
              <>
                <div
                  class={
                    item.history_count == 1 ? "chat-box active" : "chat-box "
                  }
                  onClick={(e) =>
                    linkClick("/stu/app/circular/read/" + item.id)
                  }
                >
                  <div class="chat-details">
                    <div class="text-head">
                      <h4>{item.notification_title}</h4>
                      <p class="time">
                        {momentDate(item.created_on, "DD-MM-YYYY H:MM")}
                      </p>
                    </div>
                    <div class="text-message">
                      <p>
                        {item.notification_content.length > 50
                          ? item.notification_content
                              .replace(/(<([^>]+)>)/gi, "")
                              .substring(0, 150) + "....."
                          : item.notification_content.replace(
                              /(<([^>]+)>)/gi,
                              ""
                            )}
                      </p>
                    </div>
                    <div class="sent">Sent By: {item.addedby}</div>
                  </div>
                </div>
              </>
            );
          })}
      </div>
    </>
  );
};
export default CircularList;
